/** sessionStorage: выбор из избранного для примерки (если location.state теряется в WebView / HashRouter). */
export const TRYON_PICK_STORAGE_KEY = 'mw_tryon_pick_v1';

/** localStorage: URL последнего сохранённого на сервере фото (ответ generate → user_photo_url), подставляем при следующем визите. */
/** v2: после фикса EXIF на клиенте/сервере не подставляем старые URL с кривыми исходниками. */
export const TRYON_LAST_USER_PHOTO_URL_KEY = 'mw_tryon_last_user_photo_url_v2';
